// Data sevice
import axios from 'axios'
import authHeader from './auth-header'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
const API_URL = process.env.VUE_APP_API_URL;

class CompanyTypeService  {

    index() {
        return axios.get(API_URL + 'company-types', { headers: authHeader() })
    }
    show(id) {
        return axios.get(API_URL + 'company-types/' + id, { headers: authHeader() })
    }
    store(resource) {
        return axios.post(API_URL + 'company-types', resource, { headers: authHeader() })
    }
    update(resource) {
        return axios.put(API_URL + 'company-types/' + resource.id, resource, { headers: authHeader() })
    }
    delete(resource) {
        return axios.delete(API_URL + 'company-types/' + resource.id, { headers: authHeader() })
    }

   
}

export default new CompanyTypeService()